module.exports = __webpack_public_path__ + "media/application/images/weremember-9a4970c8c3aa5168f244656fa00c450cea48fc03ba9bf559ecfabdab3770cf7a.svg";